<template>
  <div class="login">
    <el-card>
      <h2>Login</h2>
      <el-form class="login-form" ref="form">
        <el-form-item>
          <el-button :loading="loading" class="login-button" type="primary" native-type="button" @click="authenticate">Login</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script setup lang="ts">
import { useAuth } from '@/services/use-auth'
import { ElNotification } from 'element-plus';
import { onMounted, ref } from 'vue';
import { msal } from "@/services/msal-config";

const { login, handleRedirect } = useAuth();

const loading = ref(false)


const authenticate = async () => {
  const authResult: boolean = await login()
  if (!authResult) {
    ElNotification({
      title: 'Error',
      message: 'Authentication failed',
      type: 'error'
    })
  }
}

onMounted(async () => {
  try {
    await msal.initialize()
    await handleRedirect()
  } catch (e) {
    console.log(`MSAL initialization error: ${e}`)
  }
})


</script>

<style scoped>
.login {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}

.login-button {
  width: 100%;
  margin-top: 40px;
}

.login-form {
  width: 290px;
}
</style>
<style lang="scss">

</style>
